/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{text-align:center;max-width:990px;line-height:1.5}h2[_ngcontent-%COMP%]{color:#303372}div[_ngcontent-%COMP%]{margin-top:35px;margin-right:16px;margin-left:16px;padding:16px;background-color:#fff;border:1px solid #000}"];
export { styles as styles };
